import RequestedInformationApiAgency from '@/api/RequestedInformationApiAgency';

class RequestedInformationService {
	async updateAsync (...args: Parameters<typeof RequestedInformationApiAgency.update>) {
		const { data } = await RequestedInformationApiAgency.update(...args);
		return data;
	}

	async listAsync (...args: Parameters<typeof RequestedInformationApiAgency.list>) {
		const { data } = await RequestedInformationApiAgency.list(...args);
		return data;
	}

	async addAsync (...args: Parameters<typeof RequestedInformationApiAgency.add>) {
		const { data } = await RequestedInformationApiAgency.add(...args);
		return data;
	}

	async addListAsync (...args: Parameters<typeof RequestedInformationApiAgency.addList>) {
		const { data } = await RequestedInformationApiAgency.addList(...args);
		return data;
	}

	async addMultipleRequestedInformationsForOrderAsync (...args: Parameters<typeof RequestedInformationApiAgency.addMultipleRequestedInformationsForOrder>) {
		const { data } = await RequestedInformationApiAgency.addMultipleRequestedInformationsForOrder(...args);
		return data;
	}
}

export default function useRequestedInformationService () {
	return new RequestedInformationService();
}
